<div [ngClass]="{'ng-invalid ng-dirty': isCurrentlyInvalid}">
	<label>{{ 'form.field.vatType' | translate }}<span *ngIf="required" class="text-danger">*</span></label>
	<p-dropdown
		[options]="vatTypesList"
		[optionLabel]="getVatNameProperty()"
		optionValue="vat_list_id"
		[(ngModel)]="_value"
		[inputId]="controlName"
		placeholder="{{ 'shared.vatSelect.placeholder' | translate }}"
		(onChange)="onVatSelectionChange($event.value)"
		(onBlur)="onDropdownBlur()"
		[disabled]="_disabled"
		[styleClass]="isCurrentlyInvalid ? 'p-invalid w-100 flex-grow-1' : 'w-100 flex-grow-1'">
		<ng-template let-item pTemplate="item">
			{{ getVatName(item) }}
		</ng-template>
		<ng-template let-item pTemplate="selectedItem">
			{{ getVatName(item) }}
		</ng-template>
	</p-dropdown>
	<div *ngIf="isCurrentlyInvalid" class="invalid-feedback text-danger d-block">
		{{ currentErrorMessage }}
	</div>
</div>